import { StCampaignLabel, StCampaignValue } from './MetaDataStyles';
import { useTranslation } from 'react-i18next';

interface Props {
    campaignCopies: number;
}

export const Copies = (props: Props) => {
    const { t } = useTranslation();
    const campaignCopies = props.campaignCopies;

    return (
        <>
            <StCampaignLabel>{t('marketing.yourCampaigns.campaignCopies')}:</StCampaignLabel>
            <StCampaignValue>{campaignCopies}</StCampaignValue>
        </>
    );
};
